export const FETCH_POST = 'FETCH_POST';



// WEBPACK FOOTER //
// ./src/store/actions/types.js